export default "__VITE_ASSET__CNUt8MAp__"